import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Text,
  Button,
  FormErrorMessage,
  Checkbox,
  Spinner,
  Flex,
} from "@chakra-ui/react";
import { Assento } from "../../utils/interfaces";
import { Controller, useForm, useFormContext } from "react-hook-form";
import { formPoltrona, validationPoltrona } from "../../schemas/poltrona";
import { zodResolver } from "@hookform/resolvers/zod";
import InputMask from "react-input-mask";
import { shouldHideFeeDetails, vendeViagemPremiada } from "../../libs/auth";
import { useViagemPremiada } from "../../hooks/useViagemPremiada";
import { Passagem as IPassagem } from "../../utils/interfaces";
import { formatBRL } from "../../utils/currency";
import {} from "date-fns"
import { useEffect } from "react";
import { usePedidoContext } from "../../Context/PedidoContext";

interface Props {
  assento: Assento;
  isOpen: boolean;
  onClose: () => void;
  handleSubmitPassageiro: () => void;
}

export function ModalSelect({
  assento,
  isOpen,
  onClose,
  handleSubmitPassageiro,
}: Props) {
  const { setValue, getValues } = useFormContext();
  const isVendeViagemPremiada = vendeViagemPremiada();
  const hideFeeDetails = shouldHideFeeDetails();

  const selecionada: IPassagem = getValues("selecionada");

 
  const { data, isLoading } = useViagemPremiada({
    dataChegada: `${selecionada.chegadaDia} ${selecionada.chegadaHora}`,
    dataSaida: `${selecionada.saidaDia} ${selecionada.saidaHora}`,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    control,
    reset,
    watch
  } = useForm<formPoltrona>({
    defaultValues: {
      nome: "",
      documento: "",
      data_nascimento: "",
      telefone: "",
      viagem_premiada: isVendeViagemPremiada,
    },
    resolver: zodResolver(validationPoltrona),
  });

   const inputViagemPremiada = watch('viagem_premiada')


  function onSubmit(data: formPoltrona) {
    console.log(data)
    setValue("passageiro", data);
    reset();
    handleSubmitPassageiro();
  }

  const { pedido } = usePedidoContext();

  const valorViagemPremiadaSelecionada = selecionada.valorViagemPremiada ?? selecionada.valorSeguro ?? 0;
  const valorBaseSemViagemPremiada = hideFeeDetails
    ? selecionada.preco
    : selecionada.preco - valorViagemPremiadaSelecionada;
  const valorViagemPremiadaOpcional = hideFeeDetails
    ? 0
    : data?.valor ?? valorViagemPremiadaSelecionada;
  const valorTotal = hideFeeDetails
    ? (inputViagemPremiada
      ? selecionada.preco
      : selecionada.precoSemViagemPremiada ?? selecionada.preco)
    : valorBaseSemViagemPremiada + (inputViagemPremiada ? valorViagemPremiadaOpcional : 0);

  
  useEffect(() => {
    if (isOpen) {
      if(selecionada?.contexto == "ida") return;

      const bilhetes = Array.isArray(pedido?.bilhetes) ? pedido.bilhetes : [];
      if (!bilhetes.length) return;

      const bilhetesIda = bilhetes.filter(b => b.contexto === "ida");
      const bilhetesVolta = bilhetes.filter(b => b.contexto === "volta");

      const indexVolta = bilhetesVolta.length;
      const indexIda = bilhetesIda.length;

      console.log("qtde ida: " + indexIda);
      console.log("qtde volta: " + indexVolta);

      if (indexVolta >= indexIda) {
        console.log("zera o modal e volta");
        reset({
          nome: "",
          documento: "",
          telefone: "",
          data_nascimento: "",
          viagem_premiada: isVendeViagemPremiada,
        });
        return;
      }

      const bilheteIda = bilhetesIda[indexVolta];
      const passageiro = bilheteIda.passageiro;

      const formatTelefone = (telefone: string) => {
        // Garante o formato (99) 99999-9999
        return telefone.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
      };

      // Preenche os dados do formulário com o passageiro da ida correspondente
      reset({
        nome: passageiro.nome,
        documento: passageiro.documento,
        telefone: formatTelefone(passageiro.telefone ?? ""),
        data_nascimento: passageiro.data_nascimento ?? "",
        viagem_premiada: isVendeViagemPremiada,
      });

    } 
  }, [isOpen, pedido, isVendeViagemPremiada, reset, selecionada?.contexto]);


  return (
    <Modal
      size={"2xl"}
      isCentered
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent bg={"#002d4a"} color={"white"}>
        <ModalHeader>Poltrona Nº: {assento.assento}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6} display={"flex"} flexDir={"column"} gap={4}>
          <SimpleGrid>
            <FormControl isInvalid={!!errors.nome}>
              <FormLabel>Nome:</FormLabel>
              <Input
                textTransform={"uppercase"}
                bg={"white"}
                color={"black"}
                type="text"
                {...register("nome")}
                placeholder="Nome Completo do Passageiro"
                onBlur={() => trigger("nome")}
              />
              {!!errors.nome && (
                <FormErrorMessage>{errors.nome.message}</FormErrorMessage>
              )}
            </FormControl>
          </SimpleGrid>
          <SimpleGrid columns={2} gap={4}>
            <FormControl isInvalid={!!errors.documento}>
              <FormLabel>Número Documento c/ foto:</FormLabel>
              <Input
                bg={"white"}
                color={"black"}
                type="text"
                placeholder="Digite o nº do documento"
                {...register("documento")}
                onBlur={() => {trigger("documento");}}
              />
              {!!errors.documento && (
                <FormErrorMessage>{errors.documento.message}</FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.data_nascimento}>
              <FormLabel>Data de Nascimento:</FormLabel>
              <Controller
                name="data_nascimento"
                control={control}
                rules={{ required: true, minLength: 11 }}
                render={({ field }) => (
                  <InputMask
                    mask="99/99/9999"
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={() => {
                      field.onBlur();
                      trigger("data_nascimento");
                    }}
                    inputRef={field.ref}
                  >
                    {(inputProps) => (
                      <Input
                        {...inputProps}
                        bg={"white"}
                        color={"black"}
                        type="text"
                        placeholder="Data de nascimento"
                        inputRef={field.ref}
                      />
                    )}
                  </InputMask>
                )}
              />
              {!!errors.data_nascimento && (
                <FormErrorMessage>
                  {errors.data_nascimento.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </SimpleGrid>
          <FormControl isInvalid={!!errors.telefone}>
            <FormLabel>Telefone*:</FormLabel>
            <Controller
              name="telefone"
              control={control}
              render={({ field }) => (
                <InputMask
                  mask="(99) 99999-9999"
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  inputRef={field.ref}
                >
                  {(inputProps) => (
                    <Input
                      {...inputProps}
                      bg={"white"}
                      color={"black"}
                      type="text"
                      placeholder="Telefone"
                      inputRef={field.ref}
                    />
                  )}
                </InputMask>
              )}
            />
            {!!errors.telefone && (
              <FormErrorMessage>{errors.telefone.message}</FormErrorMessage>
            )}
          </FormControl>
          <Text>
            * O telefone do passageiro é essencial para contato em caso de alterações na viagem.
          </Text>
          {(isVendeViagemPremiada) && (
            <>
              <FormControl>
                <Controller
                  name="viagem_premiada"
                  control={control}
                  defaultValue={false}
                  rules={{ required: true, minLength: 11 }}
                  render={({ field }) => (
                    <Checkbox
                      isChecked={field.value}
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                    >
                      Viagem premiada - quem emite ganha prêmios
                    </Checkbox>
                  )}
                />
              </FormControl>
              {isLoading ? (
                <Spinner />
              ): (
                <Flex gap={0} alignItems={'flex-end'} direction={'column'}>
                  {!hideFeeDetails && (
                    <>
                      <Text>Valor: {formatBRL(valorBaseSemViagemPremiada)}</Text>
                      <Text color={'green.300'}>Viagem premiada: {inputViagemPremiada ? formatBRL(valorViagemPremiadaOpcional) : formatBRL(0)}</Text>
                    </>
                  )}
                  <Text fontWeight={'bold'}>Total: {formatBRL(valorTotal)}</Text>
                </Flex>
              )}
            </>
          )}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="green" onClick={handleSubmit(onSubmit)}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
